import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "@/App";
import { Loading } from "@/components/UI";
import { DEFAULT_GOOGLE_CLIENT_ID } from "@/constants";
import { CartSyncBridge } from "@/providers/CartSyncBridge";
import { CartDrawerProvider } from "@/providers/CartDrawerProvider";
import { TenantProvider } from "@/providers/TenantProvider";
import { persistor, store } from "@/store";
import { goldTheme } from "@/theme/gold-theme";
import "@/styles/global.css";

const googleClientId =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  DEFAULT_GOOGLE_CLIENT_ID ||
  "missing-google-client-id";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={<Loading fullScreen tip="Đang khôi phục storefront..." />}
        persistor={persistor}
      >
        <GoogleOAuthProvider clientId={googleClientId}>
          <ConfigProvider locale={viVN} theme={goldTheme}>
            <CartSyncBridge />
            <CartDrawerProvider>
              <TenantProvider>
                <App />
              </TenantProvider>
            </CartDrawerProvider>
          </ConfigProvider>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
